import { render, staticRenderFns } from "./PackageEditableBox.vue?vue&type=template&id=2ea210eb"
import script from "./PackageEditableBox.vue?vue&type=script&lang=ts"
export * from "./PackageEditableBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports